// Helper to disable browser inspect tools (right-click, F12, Ctrl+Shift+I/J/C, Ctrl+U)
let _disableInspectHandlers = [];

export function disableInspect(disable = true) {
	// If disable is false, enable inspect (remove restrictions)
	if (!disable) {
		enableInspect();
		return;
	}

	// Otherwise, disable inspect (add restrictions)
	// Right-click
	const contextMenuHandler = (e) => e.preventDefault();
	document.addEventListener('contextmenu', contextMenuHandler);

	// Devtools shortcuts
	const shortcutHandler = (e) => {
		// F12
		if (e.key === 'F12' || e.keyCode === 123 || e.code === 'F12') {
			e.preventDefault();
			return false;
		}
		// Ctrl+Shift+I/J/C
		if (e.ctrlKey && e.shiftKey && (
				e.key.toLowerCase() === 'i' ||
				e.key.toLowerCase() === 'j' ||
				e.key.toLowerCase() === 'c' ||
				e.code === 'KeyI' ||
				e.code === 'KeyJ' ||
				e.code === 'KeyC')) {
			e.preventDefault();
			return false;
		}
		// Ctrl+U
		if (e.ctrlKey && (e.key.toLowerCase() === 'u' || e.code === 'KeyU')) {
			e.preventDefault();
			return false;
		}
	};
	['keydown', 'keyup', 'keypress'].forEach((evt) => {
		document.addEventListener(evt, shortcutHandler, true);
	});

	_disableInspectHandlers.push({ contextMenuHandler, shortcutHandler });
}

export function enableInspect() {
	if (_disableInspectHandlers.length === 0) return;
	const { contextMenuHandler, shortcutHandler } = _disableInspectHandlers.pop();
	document.removeEventListener('contextmenu', contextMenuHandler);
	['keydown', 'keyup', 'keypress'].forEach((evt) => {
		document.removeEventListener(evt, shortcutHandler, true);
	});
}
